import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import {ForexDataSourceContainerModel} from '../../../../../../models/aggregates/erp/forex-data-source';

@Injectable({providedIn: 'root'})
export class ForexDataSourceService extends BaseApiTemplateService<ForexDataSourceContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'forex-data-source-hdr/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'forex-data-source-hdr/backoffice-ep';
    this.httpClient = http;
  }
}